export const gheWorks = {
  play: [
    {
      id: 1,
      title: '흔해빠진 일',
      year: '2024',
      image: require('./play/1. 흔해빠진 일.png')
    },
    {
      id: 2,
      title: '담화주',
      year: '2023',
      image: require('./play/2. 담화주.jpeg')
    },
    {
      id: 3,
      title: '푸른 잿빛 밤',
      year: '2022',
      image: require('./play/3. 푸른 잿빛 밤.jpeg')
    },
    {
      id: 4,
      title: '또! 오해영',
      year: '2022',
      // eslint-disable-next-line import/no-webpack-loader-syntax
      image: require('./play/4. 또 오해영.webp')
    },
    {
      id: 5,
      title: '명동로망스',
      year: '2020',
      image: require('./play/5. 명동로망스.webp')
    },
  ]
}